import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mimeTypePipe'
})
export class MimeTypePipe implements PipeTransform {

  transform(value: string): string {

    switch (value) {
      case 'application/pdf':
        return 'PDF';
      case 'application/png':
      case 'application/jpg':
      case 'application/jpeg':
        return 'Bild';
      default:
        return '';
    }
  }
}
